<template>
  <div class="pointer-events-auto w-full max-w-lg px-4 sm:px-0">
    <div class="overflow-hidden rounded-xl border border-[#dfe8c6] bg-white shadow-2xl ring-1 ring-black/5">
      <div class="flex items-start gap-4 p-5">
        <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#eef4dd]">
          <RefreshIcon class="h-5 w-5 text-[#819045]" aria-hidden="true" />
        </div>

        <div class="min-w-0 flex-1">
          <p class="text-sm font-semibold text-slate-900">Dostępna jest nowa wersja panelu.</p>
          <p class="mt-1 text-sm leading-5 text-slate-600">Odśwież stronę, żeby pobrać najnowszy build aplikacji.</p>

          <div class="mt-4 flex flex-wrap items-center gap-3">
            <button
              type="button"
              class="inline-flex items-center gap-2 rounded-md bg-[#819045] px-3.5 py-2 text-sm font-semibold text-white shadow-sm transition duration-200 ease-out hover:bg-[#6f7f45] focus:outline-none focus:ring-2 focus:ring-[#819045] focus:ring-offset-2 active:scale-[0.96]"
              @click="$emit('refresh')"
            >
              Odśwież
              <RefreshIcon class="h-4 w-4" aria-hidden="true" />
            </button>
            <button
              type="button"
              class="inline-flex items-center rounded-md px-3 py-2 text-sm font-semibold text-slate-600 transition duration-200 ease-out hover:bg-slate-100 hover:text-slate-900 focus:outline-none focus:ring-2 focus:ring-slate-300 focus:ring-offset-2 active:scale-[0.96]"
              @click="$emit('closeAlert')"
            >
              Później
            </button>
          </div>
        </div>

        <button
          type="button"
          class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-slate-400 transition duration-200 ease-out hover:bg-slate-100 hover:text-slate-700 focus:outline-none focus:ring-2 focus:ring-[#819045] focus:ring-offset-2"
          @click="$emit('closeAlert')"
        >
          <span class="sr-only">Zamknij</span>
          <XIcon class="h-5 w-5" aria-hidden="true" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { RefreshIcon, XIcon } from '@heroicons/vue/solid'

export default {
  components: {
    RefreshIcon,
    XIcon
  },

  emits: ['closeAlert', 'refresh']
}
</script>
